/**
 * サロン顧客 ID / スタッフ ID の受け渡し(MIK-699)
 *
 * 呼び出し元: snippets/customer-link.liquid(window.__mikaiLinkState を埋めてから読む)
 * 書込先の固定と署名検証は App Proxy の先の Worker 側で行う。
 *   mikai-ai-office: scripts/beplanet-customer-link/
 *   調査: docs/clients/theater-beplanet-customerid-linking-analysis-v2.0.md §9
 */
(function () {
  'use strict';

  var KEYS = {
    customerId: 'reg_customerId',
    coupon: 'reg_coupon',
    staffId: 'reg_staffId'
  };
  var TTL_MS = 24 * 60 * 60 * 1000;
  var LINK_ENDPOINT = '/apps/mikai-link/link';
  var PROBE_SESSION_KEY = 'mikai_link_probe';

  // 期限切れで捨てた値があったか。計測で「最初から無い」と「期限切れ」を分けるため
  var expiredSeen = false;


  // テーマ側(snippets/customer-link.liquid)が Liquid で埋める
  var STATE = (window.__mikaiLinkState) || { loggedIn: false, hasCustomerId: false, hasStaffId: false };

  function store(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify({ v: value, exp: Date.now() + TTL_MS }));
    } catch (e) {
      /* プライベートモード等。保存できなくても他の導線は壊さない */
    }
  }

  function read(key) {
    var raw;
    try {
      raw = localStorage.getItem(key);
    } catch (e) {
      return null;
    }
    if (!raw) return null;

    // 旧形式(素の文字列)。既に配布済みの端末に残っている在庫なので受け入れる
    if (raw.charAt(0) !== '{') return raw;

    var parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (e) {
      return null;
    }
    if (!parsed || typeof parsed.v !== 'string') return null;
    if (parsed.exp && Date.now() > parsed.exp) {
      expiredSeen = true;
      drop(key);
      return null;
    }
    return parsed.v;
  }

  function drop(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      /* noop */
    }
  }

  // --- 1) 保存(外部からの着地のときだけ) --------------------------------

  function isExternalLanding() {
    var ref = document.referrer;
    if (!ref) return true; // アプリの WebView やメールからの遷移は referrer が空
    try {
      return new URL(ref).host !== window.location.host;
    } catch (e) {
      return true;
    }
  }

  function capture() {
    // ページは限定しない(2026-09-28 代表判断)。サロンアプリの着地先はルート・
    // /account/register・/account/login と増えており、限定すると導線追加のたびに取りこぼす。
    // ページ限定は攻撃を防がない(ルートが開いている以上、攻撃者はルートを使う)。
    // 守りは「外部からの着地だけ」「24h 失効」「1 回で消す」「Worker は空欄にだけ書く」の 4 つ。
    if (!isExternalLanding()) return;
    var params = new URLSearchParams(window.location.search);
    ['customerId', 'coupon', 'staffId'].forEach(function (name) {
      var value = params.get(name);
      if (value) store(KEYS[name], value);
    });
  }

  // --- 2) /account/register の hidden input(従来どおり) ------------------

  function fillRegisterForm() {
    if (window.location.pathname !== '/account/register') return;
    var inputs = {
      customerId: 'hidden-customer-id',
      coupon: 'hidden-coupon',
      staffId: 'hidden-staff-id'
    };
    ['customerId', 'coupon', 'staffId'].forEach(function (name) {
      var saved = read(KEYS[name]);
      if (!saved) return;
      var el = document.getElementById(inputs[name]);
      if (el) el.value = saved;
    });
  }

  // --- 3) 遅延紐付け(Shop 経由で作られたアカウントの回収) ----------------

  function linkAfterLogin() {
    if (!STATE.loggedIn) return;
    if (STATE.hasCustomerId && STATE.hasStaffId) return;

    var payload = {};
    if (!STATE.hasCustomerId) {
      var customerId = read(KEYS.customerId);
      if (customerId) payload.customerId = customerId;
    }
    if (!STATE.hasStaffId) {
      var staffId = read(KEYS.staffId);
      if (staffId) payload.staffId = staffId;
    }
    if (!payload.customerId && !payload.staffId) {
      if (!STATE.hasCustomerId) probeNoId();
      return;
    }

    fetch(LINK_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (result) {
        if (!result || !result.ok) return; // 失敗時は消さない。次の来訪で再試行する
        // 書けた / 既に入っていた のどちらでも、この端末で使い終わったので消す
        if (payload.customerId) drop(KEYS.customerId);
        if (payload.staffId) drop(KEYS.staffId);
      })
      .catch(function () {
        /* 通信断。次の来訪で再試行する */
      });
  }

  // --- 4) 計測: 未連携なのにブラウザに ID が無い ----------------------------
  // 遅延紐付けが届かない層(別ブラウザ・期限切れ・サロンのリンクを経ていない)の大きさを測る。
  // 値は送らない。1 セッション 1 回だけ。フラグを fetch の前に立てるのは、
  // 再送で二重に数えるより取りこぼす方が安全なため(scripts/beplanet-customer-link/probe/README.md)

  function probeNoId() {
    try {
      if (sessionStorage.getItem(PROBE_SESSION_KEY)) return;
      sessionStorage.setItem(PROBE_SESSION_KEY, '1');
    } catch (e) {
      return; // sessionStorage が使えない環境では数えない(毎ページ送るよりよい)
    }
    fetch(LINK_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ probe: expiredSeen ? 'id_expired' : 'no_id_in_browser' }),
      credentials: 'same-origin',
      keepalive: true
    }).catch(function () {
      /* 計測なので失敗は無視する */
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    capture();
    fillRegisterForm();
    linkAfterLogin();
  });
})();
